import { Typography } from '@mui/material'
import InfoTip from 'components/InfoTip'
import { infoModalKind } from 'components/Modal/InfoModal'
import HorizontalItem from './HorizontalItem'
import Typoleton, { TypoletonProps } from './Typoleton'

interface Props extends TypoletonProps {
  left: string
  lb?: boolean
  right?: string
  rb?: boolean
  infoTip?: infoModalKind
}

/**
 * HorizontalText
 * @param lb put lb for bold text left
 * @param rb put lb for bold text right
 */
const HorizontalText = ({
  left,
  lb = false,
  right,
  rb = false,
  infoTip,
  ...props
}: Props) => {
  return (
    <HorizontalItem>
      {infoTip ? (
        <InfoTip text={left} kind={infoTip} />
      ) : (
        <Typography variant="body2" fontWeight={lb ? 600 : 400}>
          {left}
        </Typography>
      )}
      <Typoleton
        variant="body2"
        fontWeight={rb ? 600 : 400}
        color="black"
        data={right}
        sksize="md"
        {...props}
      />
    </HorizontalItem>
  )
}

export default HorizontalText
